import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    paddingLeft: "20px",
  },
  customContainer: {
    display: "flex",
    flexDirection: "row",
    width: "97%",
    marginTop: "16px",
  },
  iconStyle: {
    marginTop: "2px",
  },
  message: {
    marginLeft: theme.spacing(1),
    fontSize: "12px",
    lineHeight: "14px",
  },
  customMessage: {
    marginLeft: theme.spacing(1),
    fontSize: "14px",
    lineHeight: "16px",
  },
}));

export default useStyles;
